import TpWidgetMicro from "../common/TpWidgetMicro";
import TpWidget from "../../atoms/document/TpWidget";
import AdaptiveCriticalImage from "../../atoms/AdaptiveCriticalImage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function Hero({ data }) {
  const appMode = process.env.APP_MODE;
  const signupLink = data?.cta?.href?.[appMode] || data?.cta?.href;
  const ctaAttrs = {
    target: data.cta?.isExternal ? "_blank" : "_self",
    rel: data.cta?.isExternal ? "noopener noreferrer" : undefined,
  };

  return (
    <section
      className={`container grid--default hero--default lg:pb-10 md:pb-10 has-align-top`}
    >
      <article className={`lg:maxw-lg text-left`}>
        <h1 className="text-xl lg:pt-5">{data.title}</h1>
        {data.desc &&
          data.desc.map((item, index) => (
            <p
              className="lg:maxw-md lg:mt-2 lg:mb-2"
              key={index}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        {data.cta && (
          <div
            className={`lg:mt-5 md:mt-3  ${
              data.ctaSecondary ? "fx md:fx--c" : ""
            }`}
          >
            <a
              href={signupLink}
              className="btn-primary md:w-100"
              {...ctaAttrs}
              id={data.cta.id}
            >
              <span>{data.cta.text}</span>
            </a>
            {data.ctaSecondary ? (
              <a
                href={data.ctaSecondary.href}
                className="btn-quaternary md:w-100 lg:ml-5 md:mt-2"
                {...ctaAttrs}
                id={data.ctaSecondary.id}
              >
                <span>{data.ctaSecondary.text}</span>
              </a>
            ) : (
              ""
            )}
          </div>
        )}
        {data.hasTpWidget && (
          <TpWidgetMicro
            className={`lg:mt-5 md:mt-3 md:pt-2 ${data.cta ? "" : "md:ml-0"}`}
          />
        )}
      </article>
      <figure className="md:mt-5 lg:maxw-lg">
        <picture>
          <AdaptiveCriticalImage
            src={data.img.src}
            alt={data.img.alt}
            mobile={data.img.prefixes.mobile}
            dpi={data.img.prefixes.dpi}
            dimensions={data.img.dimensions}
            className="img-fit"
          />
        </picture>
      </figure>
      <style jsx>
        {`
          @media (min-width: ${viewport.tablet.sm}) {
            .hero--default {
              margin-top: 88px;
              padding-top: 72px;
            }
            .hero--default article {
              padding-right: 52px;
            }
            .hero--default article .text-xl {
              margin-bottom: 24px;
            }
          }
        `}
      </style>
    </section>
  );
}
